// Navbar.jsx

import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Dropdown, Space } from "antd";
import axios from "../../utils/request";
import { DownOutlined, CheckOutlined } from "@ant-design/icons";
import "./index.css";

const MenuList = [
  {
    to: "/",
    name: "网站首页",
    enName: "Home",
  },
  {
    to: "/about",
    name: "关于我们",
    enName: "About",
  },
  {
    to: "/news",
    name: "新闻中心",
    enName: "News",
  },
  {
    to: "/product",
    name: "产品分类",
    enName: "Product",
  },
  {
    to: "/case",
    name: "精彩案例",
    enName: "Case",
  },
  {
    to: "/talents",
    name: "人才招聘",
    enName: "Talents",
  },
  {
    to: "/leaveWord",
    name: "在线留言",
    enName: "LeaveWord",
  },
  {
    to: "/tantact",
    name: "联系我们",
    enName: "Tantact",
  },
];
const langLabels = [
  {
    label: "简体中文",
    key: "ch",
  },
  {
    label: "English",
    key: "en",
  },
];

const Navbar = () => {
  const location = useLocation();
  const language = sessionStorage.getItem("lang") || "ch";
  const [langActive, setLangActive] = useState(false);
  const [miniMenuActice, setMiniMenuActice] = useState(false);
  const [miniLangActive, setMiniLangActive] = useState(false);
  const [firstTabs, setFirstTabs] = useState<any>([]);
  const [cases, setCases] = useState<any>([]);
  const navigate = useNavigate();
  const getCase = async () => {
    const res: any = await axios.get("/index/cases");
    console.log(res);
    if (res.code === 200) {
      setCases(res.data.data);
    }
  };
  const getTabs = async () => {
    const res: any = await axios.get("/index/product/class");
    if (res.code === 200) {
      setFirstTabs(res.data);
    }
  };
  useEffect(() => {
    getTabs();
    getCase();
  }, []);
  return (
    <>
      <div className="nav">
        <div className="container">
          <Link to="/">
            <img className="logo" src="/images/logo1.jpg" alt="logo" />
          </Link>
          <div className="menu">
            {MenuList.map((item) => {
              return (
                <div
                  className={`menu-li ${
                    location.pathname === item.to ? "active" : ""
                  }`}
                  key={item.to}
                >
                  <Link to={item.to}>
                    {language === "ch" ? item.name : item.enName}
                  </Link>
                  {item.to === "/product" ? (
                    <div className="sc-t-li-content">
                      {firstTabs?.map((product: any) => {
                        return (
                          <div
                            className="sc-t-li-c-li"
                            onClick={() => {
                              navigate("/product", {
                                state: {
                                  id: product?.id,
                                },
                              });
                            }}
                          >
                            {product.title}
                          </div>
                        );
                      })}
                    </div>
                  ) : null}
                  {item.to === "/case" ? (
                    <div className="sc-t-li-content">
                      {cases?.map((item: any) => {
                        return (
                          <div
                            className="sc-t-li-c-li"
                            onClick={() => {
                              navigate("/detail", {
                                state: {
                                  url: "/index/cases/detail",
                                  id: item?.id,
                                },
                              });
                            }}
                          >
                            {item.title}
                          </div>
                        );
                      })}
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
        <div className="right">
          <Dropdown
            open={langActive}
            onOpenChange={(open: boolean) => {
              setLangActive(open);
            }}
            dropdownRender={() => {
              return (
                <div className="label-box">
                  {langLabels.map((item) => {
                    return (
                      <div
                        className="label"
                        key={item.key}
                        onClick={() => {
                          window.location.reload();
                          sessionStorage.setItem("lang", item.key);
                        }}
                      >
                        {item.label}
                      </div>
                    );
                  })}
                </div>
              );
            }}
          >
            <div className={`language-box ${langActive ? "active" : ""}`}>
              <a onClick={(e) => e.preventDefault()}>
                <Space>
                  {language === "ch" ? "语言" : "language"}
                  <DownOutlined />
                </Space>
              </a>
            </div>
          </Dropdown>
        </div>
      </div>
      <div className="nav mini">
        <Link to="/">
          <img className="logo" src="/images/logo.jpg" alt="logo" />
        </Link>
        <div className="right">
          <div
            className="mini-lang"
            onClick={() => {
              setMiniMenuActice(false);
              setMiniLangActive(!miniLangActive);
            }}
          >
            {language === "ch" ? "语言" : "language"}
            <DownOutlined />
          </div>
          <div
            className="xian-box"
            onClick={() => {
              setMiniLangActive(false);
              setMiniMenuActice(!miniMenuActice);
            }}
          >
            <i className="xian"></i>
            <i className="xian"></i>
            <i className="xian"></i>
          </div>
        </div>
        {miniMenuActice ? (
          <div className="menu-column-cantainer">
            {MenuList.map((item) => {
              return (
                <div
                  className={`menu-li ${
                    location.pathname === item.to ? "active" : ""
                  }`}
                  key={item.to}
                  onClick={() => {
                    setMiniMenuActice(false);
                    navigate(item.to);
                  }}
                >
                  <a>{language === "ch" ? item.name : item.enName}</a>
                  <CheckOutlined />
                </div>
              );
            })}
          </div>
        ) : null}
        {miniLangActive ? (
          <div className="menu-column-cantainer">
            {langLabels.map((item) => {
              return (
                <div
                  className={`menu-li ${language === item.key ? "active" : ""}`}
                  key={item.key}
                  onClick={() => {
                    navigate("/");
                    setMiniLangActive(false);
                    sessionStorage.setItem("lang", item.key);
                  }}
                >
                  <div className="text">{item.label}</div>
                  <CheckOutlined />
                </div>
              );
            })}
          </div>
        ) : null}
      </div>
    </>
  );
};

export default Navbar;
